import DragAndDropInterface from './interface'

const DragAndDropSingleton = new DragAndDropInterface()

export default DragAndDropSingleton
